import type { ModelLead, ModelLeadsSearchFilter } from '@app/api/Leads/types';
import type { WithActiveBranchId } from '@app/api/shared';

export enum SalesFunnelsEndpoints {
  Get = 'Get',
  ListForFilters = 'ListForFilters',
  List = 'List',
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  CheckForLeads = 'CheckForLeads',
  GetUserSalesFunnels = 'GetUserSalesFunnels',
  GetSalesFunnelLeads = 'GetSalesFunnelLeads',
}

export interface SalesFunnelStageFilterListDto {
  Id: number;
  Name: string | null;
  Color: string | null;
}

export interface SalesFunnelFilterDto {
  Id: number;
  Name: string | null;
  Stages: SalesFunnelStageFilterListDto[] | null;
}

export interface SalesFunnelListStageDto {
  Id: number;
  Name: string | null;
  Description: string | null;
  Color: string | null;
  Order: number;
  Category: number;
}

export interface SalesFunnelListDto {
  Id: number;
  Name: string | null;
  Description: string | null;
  Stages: SalesFunnelListStageDto[] | null;
  CountUnreadLogs: number | null;
}

export interface SalesFunnelDto {
  Name: string | null;
  Description: string | null;
  UseAutoStageSwitch: boolean;
  ClientServices: number[] | null;
  Id: number;
}

export interface WriteSalesFunnelDto {
  Name: string | null;
  Description: string | null;
  UseAutoStageSwitch: boolean;
  SyncStagesInExistedLeads: boolean;
  ClientServices: number[] | null;
}

export interface ModelSaleFunnelStage {
  Id: number;
  Name: string | null;
  Description: string | null;
  Color: string | null;
  Order: number;
}

export interface ModelSalesFunnelWithStages {
  Id: number;
  Name: string | null;
  Description: string | null;
  CountLeads: number;
  Stages: ModelSaleFunnelStage[] | null;
}

export interface ModelSalesFunnelLeadsFilter {
  SalesFunnelId: number;
  LeadsFilter: ModelLeadsSearchFilter;
}

export interface ModelSalesFunnelStageLeads {
  StageId: number;
  StageName: string | null;
  StageDescription: string | null;
  Color: string | null;
  TotalLeads: number;
  Leads: ModelLead[] | null;
}

export interface ModelSalesFunnelLeadsSearchResult {
  Timestamp: string;
  SalesFunnelId: number;
  LeadsFilter: ModelLeadsSearchFilter;
  StageLeads: ModelSalesFunnelStageLeads[] | null;
}

export type GetSalesFunnelRequest = WithActiveBranchId<{
  id: number;
}>;
export type GetSalesFunnelsForFiltersRequest = WithActiveBranchId;
export type ListSalesFunnelsRequest = WithActiveBranchId;
export type CreateSalesFunnelRequest = WithActiveBranchId<{
  data: WriteSalesFunnelDto;
}>;
export type UpdateSalesFunnelRequest = WithActiveBranchId<{
  id: number;
  data: WriteSalesFunnelDto;
}>;
export type DeleteSalesFunnelRequest = WithActiveBranchId<{
  id: number;
}>;
export type CheckSalesFunnelForLeadsRequest = WithActiveBranchId<{
  id: number;
}>;
export type GetUserSalesFunnelsRequest = WithActiveBranchId;
export type GetSalesFunnelLeadsRequest = WithActiveBranchId<{
  data: ModelSalesFunnelLeadsFilter;
}>;

export type GetSalesFunnelResponse = SalesFunnelDto;
export type GetSalesFunnelsForFiltersResponse = SalesFunnelFilterDto[];
export type ListSalesFunnelsResponse = SalesFunnelListDto[];
export type CreateSalesFunnelResponse = SalesFunnelDto;
export type UpdateSalesFunnelResponse = SalesFunnelDto;
export type DeleteSalesFunnelResponse = void;
export type CheckSalesFunnelForLeadsResponse = boolean;
export type GetUserSalesFunnelsResponse = ModelSalesFunnelWithStages[];
export type GetSalesFunnelLeadsResponse = ModelSalesFunnelLeadsSearchResult;
